<template>
  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <v-layout wrap>
      <v-flex xs12 class="pa-1" v-if="banktransferinfo_photo">
        <label for="bankTransferInfoPhoto">{{ $t('Bank Transfer Info Photo') }}</label>

        <v-layout>
          <v-flex>
            <div v-if="isEdit" style="max-width: 600px">
              <uploadfile
                v-model="banktransferinfo_photo.contentvalue"
                :height="250"
                @onUploaded="onUploaded"
              ></uploadfile>
            </div>
            <div v-else style="max-width: 600px">
              <template v-if="banktransferinfo_photo.contentvalue">
                <img
                  :src="banktransferinfo_photo.contentvalue"
                  alt
                  class="responsive-img"
                  style="border-radius: 10px"
                />
              </template>
              <template v-else>
                <img
                  src="/static/img/assets/generic/generic_default_thumbnail.png"
                  class="responsive-img"
                  style="border-radius: 10px"
                />
              </template>
            </div>
          </v-flex>
          <v-flex>
            <v-btn
              fab
              small
              v-if="isEdit"
              @click="banktransferinfo_photo.contentvalue = ''"
              depressed
              ><v-icon>delete</v-icon></v-btn
            >
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12 class="pa-1" v-if="banktransferinfo">
        <label for="bankTransferInfo">{{ $t('Bank Transfer Info') }}</label>
        <template v-if="isEdit">
          <div class="form-control">
            <textarea
              class="mb-2"
              :placeholder="$t('Bank Transfer Info')"
              style="resize: vertical;min-height: 90px"
              rows="3"
              v-model="banktransferinfo.contentvalue"
            ></textarea>
          </div>
        </template>
        <template v-else>
          <h3 class="primary-color mt-3 mb-3">
            <template v-if="banktransferinfo.contentvalue">
              <nl2br
                tag="span"
                :text="banktransferinfo.contentvalue"
                :title="banktransferinfo.contentvalue"
                style="word-wrap: break-word;"
              />
            </template>
            <template v-else>-</template>
          </h3>
        </template>
      </v-flex>
      <v-flex xs12>
        <div for="bankTransferInfo" class="primary--text">
          {{ $t('Turn on to allow customers submitting the payment information later.') }}
        </div>
        <div class="caption">
          {{
            $t(
              'When enable this section, customers will be able to confirm the order without attaching a slip. Also, customers can send the payment slip in chat later. After receiving the order number, the chatbot system will automatically collect the informed slip immediately.'
            )
          }}
        </div>
        <span class="caption primary--text">
          {{ $t('Note: This feature is available only on Facebook platform.') }}</span
        >
        <div>
          <toggle-button
            class="mt-2"
            :value="selectedBot.payment_slip_status"
            :sync="true"
            :color="$vuetify.theme.success"
            @change="onChangePaymentSlipStatus"
            :labels="{ checked: 'ON', unchecked: 'OFF' }"
            style="display: inline-block"
          />
        </div>
      </v-flex>
      <v-flex xs12>
        <div class="text-xs-center" style="margin-bottom: 15px;">
          <template v-if="isEdit">
            <v-btn @click="reset" outline color="grey">
              {{ $t('cancel') }}
            </v-btn>
            <v-btn @click="saveContent" depressed color="primary">
              {{ $t('Save') }}
            </v-btn>
          </template>
        </div>
      </v-flex>
    </v-layout>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'

import api from '@/api'

import uploadfile from '@/components/elements/uploadfile'
import Nl2br from 'vue-nl2br'
import { cloneDeep } from 'lodash'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  props: ['init', 'isEdit'],
  data: function() {
    return {
      banktransferinfo_photo: undefined,
      banktransferinfo: undefined
    }
  },
  components: {
    uploadfile,
    Nl2br,
    ToggleButton
  },

  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  created() {
    this.banktransferinfo_photo = Object.assign({}, this.init.banktransferinfo_photo)
    this.banktransferinfo = Object.assign({}, this.init.banktransferinfo)

    //cache
    this.cached_banktransferinfo_photo = Object.assign({}, this.init.banktransferinfo_photo)
    this.cached_banktransferinfo = Object.assign({}, this.init.banktransferinfo)
  },
  methods: {
    async onChangePaymentSlipStatus() {
      let status = null

      if (
        this.selectedBot.payment_slip_status == null ||
        this.selectedBot.payment_slip_status == undefined
      ) {
        status = true
      } else {
        status = !this.selectedBot.payment_slip_status
      }
      try {
        var response = await api.setPaymentSlip({ pageid: this.selectedBot.pageid, status: status })
        this.$store.commit('SELECT_NEW_BOT', {
          ...this.selectedBot,
          payment_slip_status: status
        })
      } catch (error) {
        status = !status
      } finally {
        this.$store.commit('SELECT_NEW_BOT', {
          ...this.selectedBot,
          payment_slip_status: status
        })
      }
    },
    reset: function() {
      var vm = this
      this.banktransferinfo_photo = cloneDeep(this.cached_banktransferinfo_photo)
      this.banktransferinfo = cloneDeep(this.cached_banktransferinfo)
      vm.$emit('onSave')

      vm.$emit('reset')
    },
    saveContent: function() {
      var vm = this
      vm.sendRequest(this.banktransferinfo_photo)
      vm.sendRequest(this.banktransferinfo)
      this.cached_banktransferinfo_photo = Object.assign({}, this.banktransferinfo_photo)
      this.cached_banktransferinfo = Object.assign({}, this.banktransferinfo)
      vm.$emit('onSave')
    },
    onUploaded: function(image) {
      this.banktransferinfo_photo.contentvalue = image
    },
    sendRequest: function(content, callback) {
      if (content.contentvalue === null) {
        content.contentvalue = ''
      }
      
      api.updateConfig(content, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
      })
    }
  },
  watch: {
    init: function() {
      this.banktransferinfo = Object.assign({}, this.init.banktransferinfo)
      this.cached_banktransferinfo = Object.assign({}, this.init.banktransferinfo)

      this.banktransferinfo_photo = Object.assign({}, this.init.banktransferinfo_photo)

      //cache
      this.cached_banktransferinfo_photo = Object.assign({}, this.init.banktransferinfo_photo)
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/setting/ecommerce/TransferPayment.vue